import { render, staticRenderFns } from "./dialogLoader.vue?vue&type=template&id=4184aff4&scoped=true"
import script from "./dialogLoader.vue?vue&type=script&lang=js"
export * from "./dialogLoader.vue?vue&type=script&lang=js"
import style0 from "./dialogLoader.vue?vue&type=style&index=0&id=4184aff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4184aff4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VCard,VCardText,VDialog,VProgressLinear})
